import { AnimatedShield } from "./AnimatedShield";

export interface EncryptedShieldPanelProps {
  tone?: string;
  cut?: string;
  glow?: string;
  gradientFrom?: string;
  gradientTo?: string;
  dataLabels?: string[];
  className?: string;
}

const DEFAULT_LABELS = ["BSB", "ACCT", "EMAIL", "PHONE", "ADDR", "ID#", "ABN", "NAME"];

export function EncryptedShieldPanel({
  tone = "hsl(var(--brand-bone))",
  cut = "hsl(var(--brand-brass))",
  glow = "hsl(var(--brand-brass))",
  gradientFrom = "hsl(var(--brand-forest))",
  gradientTo = "hsl(168, 40%, 12%)",
  dataLabels = DEFAULT_LABELS,
  className,
}: EncryptedShieldPanelProps) {
  return (
    <div className={className ?? "relative aspect-square max-w-md mx-auto"}>
      <div
        className="absolute inset-0 rounded-[2rem] p-10"
        style={{ backgroundImage: `linear-gradient(to bottom right, ${gradientFrom}, ${gradientTo})` }}
      >
        <AnimatedShield
          beat="data-flow"
          tone={tone}
          cut={cut}
          glow={glow}
          dataLabels={dataLabels}
        />
      </div>
    </div>
  );
}
